import React from 'react';

const TermsAndConditions = () => {
  return (
    <div>
      Terms & Conditions
    </div>
  );
}

export default TermsAndConditions;
